class filterFunctions {
    constructor() {
        //window.onerror = this.silentErrorHandler;
        this.filterForm = document.querySelector('.qm-filter-bar');
        this.initializeOpenFilter();

        document.addEventListener('click', (event) => {
            let isChild = this.isDescendant(document.querySelector('.qm-filter'), event.target)
            if (document.querySelector('.qm-filter__dropdown.active') !== null && !isChild) {
                document.querySelector('.qm-filter__dropdown.active').classList.remove('active')
            }
        })
    }

    isDescendant = (parent, child) => {
        let node = child.parentNode;
        while (node != null) {
            if (node === parent) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    }

    silentErrorHandler = () => {
        console.warn('JavaScript errors are suppressed')
        return true
    }

    initializeOpenFilter = function () {
        let dropdown = this.filterForm.querySelectorAll('.qm-filter__dropdown'),
            subDropdown = this.filterForm.querySelectorAll('.has-children'),
            resetButton = this.filterForm.querySelector('.reset');

        Array.from(dropdown).forEach((element, index) => {
            element.querySelector('.qm-filter__dropdown__title').addEventListener('click', () => {
                Array.from(dropdown).forEach((el, i) => {
                    if (i !== index) {
                        el.classList.remove('active')
                    }
                })
                if (element.classList.contains('active')) {
                    element.classList.remove('active');
                } else {
                    element.classList.add('active');
                }
            });
        })

        Array.from(subDropdown).forEach(element => {
            element.addEventListener('change', () => {
                let subDropdownElement = element.parentNode.nextElementSibling,
                    inputLabels = this.filterForm.querySelectorAll('.' + element.id + '');

                subDropdownElement.classList.toggle('active');
                Array.from(inputLabels).forEach(element => {
                    element.checked = !element.checked;
                })
            });
        })

        resetButton.addEventListener('click', () => {
            Array.from(dropdown).forEach(element => {
                element.classList.remove('active');
            })
        });

        new FilterActions().fetchFilter();
    }
}



